import { heroChips } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
        <span className="anim-drift select-none font-heading text-[34vw] font-black leading-none text-background-100/80 md:text-[22vw]" aria-hidden="true">
          瓜
        </span>
      </div>

      <div className="relative mx-auto w-full max-w-5xl px-4 pb-16 pt-16 text-center md:px-6 md:pb-24 md:pt-24">
        <p className="anim-fade-up mx-auto inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50/70 px-4 py-1.5 text-xs font-semibold tracking-wide text-foreground-700">
          <i className="ri-megaphone-line text-sm text-accent-600"></i>
          吃瓜王 · 2026 年度盘点
          <span className="text-background-300">/</span>
          全年瓜单已开席
        </p>

        <h1 className="anim-fade-up mx-auto mt-7 max-w-3xl font-heading text-4xl font-black leading-tight tracking-tight md:text-6xl md:leading-tight">
          这一年，
          <span className="text-primary-600">瓜管够。</span>
        </h1>

        <p
          className="anim-fade-up mx-auto mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg"
          style={{ animationDelay: '0.08s' }}
        >
          从娱乐到社会，全年大瓜一网打尽。年度盘点新鲜出炉，一颗不落，带你把那些让你惊呼的瞬间，重新围观一遍。
        </p>

        <div className="anim-fade-up mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" style={{ animationDelay: '0.16s' }}>
          <a
            href="#king"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            先看年度瓜王榜
            <i className="ri-arrow-down-line text-base"></i>
          </a>
          <a
            href="#talk"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-background-400 hover:text-foreground-950 sm:w-auto"
          >
            <i className="ri-chat-3-line text-base"></i>
            进楼聊两句
          </a>
        </div>

        <dl
          className="anim-fade-up mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-3 sm:grid-cols-3"
          style={{ animationDelay: '0.24s' }}
        >
          {heroChips.map((c) => (
            <div
              key={c.label}
              className="flex items-center justify-center gap-3 rounded-2xl border border-background-200 bg-background-50/60 px-5 py-4"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                <i className={`${c.icon} text-lg`}></i>
              </span>
              <span className="text-left">
                <span className="block font-label text-lg font-bold leading-tight text-foreground-950">{c.value}</span>
                <span className="block text-xs text-foreground-600">{c.label}</span>
              </span>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}